import { PaymentType } from '@/types/tournament.model';

const DEFAULT_CURRENCY = {
  isoCode: 'ARS',
  name: 'Peso Argentino',
};

export interface PricingStepConfig {
  currency?: {
    isoCode: string;
    name: string;
  };
  allowedPaymentTypes?: PaymentType[];
  showFeeBreakdown?: boolean;
  isBalanceRestricted?: boolean;
}

export const DEFAULT_PRICING_STEP_CONFIG: PricingStepConfig = {
  currency: DEFAULT_CURRENCY,
  allowedPaymentTypes: [
    PaymentType.MERCADOPAGO,
    PaymentType.CASH,
    PaymentType.ALL,
  ],
  showFeeBreakdown: true,
  isBalanceRestricted: false,
};
